module.exports = __webpack_public_path__ + "assets/img/integration-settings-toggle-icon.8d301880.svg";